export default __webpack_public_path__ + "static/media/chevron-up.ec396f96.svg";